module.exports = __webpack_public_path__ + "static/media/auction.8b316355.png";